import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useCgmDisplayMode } from '../contexts/CgmDisplayModeContext';

/** Display-mode boundary only; authentication and tenant permissions remain upstream. */
const CgmExpertRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isExpert, setMode } = useCgmDisplayMode();
  const { t } = useTranslation('common');
  const titleId = useId();

  if (isExpert) return <>{children}</>;

  // Keep the requested URL, including the equipment identifier, until the user
  // explicitly switches modes. Never silently redirect a diagnostic link home.
  return (
    <section className="m-4 rounded-xl border p-6" aria-labelledby={titleId}>
      <h1 id={titleId} className="text-lg font-semibold">{t('cgmExpertRequired')}</h1>
      <p className="mt-2">{t('cgmExpertRequiredDescription')}</p>
      <button type="button" className="mt-4 min-h-[44px] rounded-lg border px-4 py-2"
        onClick={() => setMode('expert')}>
        {t('cgmSwitchToExpert')}
      </button>
    </section>
  );
};

export default CgmExpertRoute;
